export function isNetworkError(err) {
  if (!err) {
    return false;
  }
  if (err.status) {
    return false;
  }
  const name = err.name || '';
  const msg = String(err.message || err).toLowerCase();
  return (
    name === 'TypeError' ||
    msg.includes('load failed') ||
    msg.includes('failed to fetch') ||
    msg.includes('networkerror') ||
    msg.includes('network request failed') ||
    msg.includes('the internet connection appears to be offline')
  );
}

export function isRetryableRequestError(err) {
  if (isNetworkError(err)) {
    return true;
  }
  const status = err && err.status;
  return status === 502 || status === 503 || status === 504;
}

export function formatRequestError(err, fallback) {
  const body = err && err.body;
  const bodyMsg = body && (body.message || body.errors);
  if (typeof bodyMsg === 'string' && bodyMsg.trim()) {
    return bodyMsg;
  }
  if (isNetworkError(err)) {
    return (
      fallback ||
      'Не удалось выполнить запрос. Проверьте интернет и попробуйте ещё раз.'
    );
  }
  if (err && typeof err.message === 'string' && err.message.trim()) {
    const msg = err.message.trim();
    const hidden =
      msg.toLowerCase() === 'load failed' ||
      err.name === 'TypeError' ||
      msg === 'Wallet card was not issued' ||
      msg === 'Wallet card was not loaded';
    if (!hidden) {
      return msg;
    }
  }
  return (
    fallback ||
    'Не удалось выполнить запрос. Проверьте интернет и попробуйте ещё раз.'
  );
}
